import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useDormitorySolitaryFloors() {
  const [floors, setFloors] = useState<DormitoryFloorEntity[]>([]);
  const [floorsError, setError] = useState('');
  const [floorsLoading, setLoading] = useState(false);

  const fetchFloors = useCallback(async (dormitoryId: number, blockId: number) => {
    setLoading(true);
    try {
      const res = await DormitoryLegacyHttp.fetchSolitaryFloors(dormitoryId, blockId);
      setFloors(res.data.payload ?? []);
    }
    catch (e) {
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { fetchFloors, floors, floorsLoading, floorsError };
}
